module.exports = __webpack_public_path__ + "img/tony-grainger.5cd8e1fc.jpg";